import { Hourglass, ShieldAlert, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useContext } from 'react';
import { UserContext } from '../context/user/UserContext';

export default function ApprovalPendingModal() {
  const { showPendingModal: isOpen, setShowPendingModal: setShowModal } = useContext(UserContext);
  const onClose = () => setShowModal(false);
  
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          className="relative w-full max-w-md bg-white rounded-3xl overflow-hidden shadow-2xl"
        >
          {/* Decorative Background */}
          <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-br from-indigo-500 to-purple-600 opacity-10" />
          
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 rounded-full hover:bg-gray-100 transition-colors z-10"
          >
            <X size={20} className="text-gray-500" />
          </button>

          <div className="px-8 pt-12 pb-8 flex flex-col items-center text-center">
            {/* Icon Container */}
            <div className="relative mb-6">
              <div className="w-20 h-20 rounded-2xl bg-indigo-50 flex items-center justify-center">
                <Hourglass size={40} className="text-indigo-600 animate-pulse" />
              </div>
              <div className="absolute -bottom-2 -right-2 w-8 h-8 rounded-full bg-amber-100 border-2 border-white flex items-center justify-center">
                <ShieldAlert size={16} className="text-amber-600" />
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-3">
              Action Restricted
            </h2>
            
            <p className="text-gray-600 leading-relaxed max-w-[280px] mb-8">
              Your account is currently <span className="text-indigo-600 font-semibold text-sm px-2 py-0.5 bg-indigo-50 rounded-full">Pending Approval</span> and cannot perform database actions yet.
            </p>

            <div className="w-full space-y-3 bg-gray-50 p-5 rounded-2xl text-left border border-gray-100 mb-8">
              <div className="flex gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-indigo-400 mt-1.5 shrink-0" />
                <p className="text-xs text-gray-500">You can still explore all features and categories.</p>
              </div>
              <div className="flex gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-indigo-400 mt-1.5 shrink-0" />
                <p className="text-xs text-gray-500">Wait for our team to verify your profile (usually 24-48h).</p>
              </div>
            </div>

            <button
              onClick={onClose}
              className="w-full py-4 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-2xl transition-all shadow-lg shadow-indigo-200 active:scale-95"
            >
              Understand
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
